import type { ReactNode } from 'react';
import { useGo } from '../../app/navigation';
import { Icon, type IconName } from '../../ui/icons';
import { Rich } from '../../ui/Rich';
import { vars } from '../../ui/style';

/** Page frame for a tool: back link, icon, title and description. */
export function ToolShell({
  title,
  desc,
  icon,
  children,
}: {
  title: string;
  desc: string;
  icon: IconName;
  children: ReactNode;
}) {
  const go = useGo();
  return (
    <div className="ex-page" style={vars({ '--mod': 'var(--accent)' }, { maxWidth: '900px' })}>
      <button type="button" className="link-back" onClick={() => go('araclar')}>
        <Icon name="left" />
        <span>Araçlar</span>
      </button>
      <div className="mod-head">
        <div className="mod-icon">
          <Icon name={icon} />
        </div>
        <div className="mod-titles">
          <h1>{title}</h1>
          <p>
            <Rich text={desc} />
          </p>
        </div>
      </div>
      {children}
    </div>
  );
}
